import { useEffect, useState } from 'react'
import type { Session } from '@supabase/supabase-js'
import { getCurrentSession, onAuthSessionChange, signOut } from './auth/session'
import { listExercises, type Exercise } from './features/exercises/api'
import { PlanTrainingLauncher } from './features/plans/PlanTrainingLauncher'
import { WorkoutScreen } from './features/workouts/WorkoutScreen'

export function App() {
  const [session, setSession] = useState<Session | null>(null)
  const [loading, setLoading] = useState(true)
  const [exercises, setExercises] = useState<Exercise[]>([])
  const [activeWorkoutId, setActiveWorkoutId] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    getCurrentSession().then(setSession).catch((value) => setError(value instanceof Error ? value.message : 'Session konnte nicht geladen werden.')).finally(() => setLoading(false))
    return onAuthSessionChange(setSession)
  }, [])

  useEffect(() => {
    if (!session) return
    listExercises().then(setExercises).catch((value) => setError(value instanceof Error ? value.message : 'Übungen konnten nicht geladen werden.'))
  }, [session])

  if (loading) return <main className="shell"><p>Himothy wird geladen…</p></main>
  if (!session) return <main className="shell"><section className="card hero"><p className="eyebrow">HIMOTHY</p><h1>Training. Klar geführt.</h1><p>Die rekonstruierte App verwendet weiterhin die bestehende Himothy Authentifizierung und Produktionsdaten.</p>{error && <p className="error">{error}</p>}</section></main>

  return <main className="shell">
    <header className="topbar"><div><p className="eyebrow">HIMOTHY</p><strong>{activeWorkoutId ? 'Aktives Training' : 'Training'}</strong></div><button onClick={() => void signOut()}>Abmelden</button></header>
    {error && <p className="error">{error}</p>}
    {activeWorkoutId
      ? <WorkoutScreen athleteId={session.user.id} sessionId={activeWorkoutId} onFinished={() => setActiveWorkoutId(null)} />
      : <>
          <PlanTrainingLauncher athleteId={session.user.id} onOpenWorkout={setActiveWorkoutId} />
          <section className="card catalogue-note"><p className="eyebrow">ÜBUNGSKATALOG</p><p>{exercises.length} aktive Übungen werden live aus dem bestehenden Himothy Backend geladen.</p></section>
        </>}
  </main>
}
